module.exports = __webpack_public_path__ + "img/user-07.c63e602a.jpg";